import React from 'react';
import { FaRunning, FaMapMarkerAlt, FaCheckCircle } from 'react-icons/fa';
import { CheckHistoryEntry } from '../types';

interface CheckInHistoryProps {
  history: CheckHistoryEntry[];
  isLoading?: boolean;
  error?: string | null;
}

const CheckInHistory: React.FC<CheckInHistoryProps> = ({ history, isLoading, error }) => {
  return (
    <div className="saved-locations">
      <h3>TimeIn/TimeOut History</h3>
      <div className="location-list">
        {history.slice().reverse().map((entry, index) => (
          <div key={index} className={`history-entry ${entry.type === 'in' ? 'check-in' : 'check-out'}`}>
            <div className="history-time">
              {entry.time.toLocaleString()}
            </div>
            <div className="history-details">
              <span className="history-type">
                {entry.type === 'in' ? (
                  <><FaCheckCircle className="inline-icon check-in-icon" /> Time In ({entry.time.getHours() < 12 ? 'AM' : 'PM'})</>
                ) : (
                  <><FaRunning className="inline-icon check-out-icon" /> Time Out ({entry.time.getHours() < 12 ? 'AM' : 'PM'})</>
                )}
              </span>
              <span className="history-location">
                <FaMapMarkerAlt className="inline-icon" /> {entry.location}
              </span>
            </div>
          </div>
        ))}
        {isLoading && (
          <div className="history-loading">
            Loading TimeIn/TimeOut history...
          </div>
        )}
        {error && (
          <div className="history-error">
            {error}
          </div>
        )}
        {!isLoading && !error && history.length === 0 && (
          <div className="no-history">
            No TimeIn/TimeOut history available
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckInHistory;
